import { Skeleton } from '@mui/material';

function HeaderFlagsLoader(): JSX.Element {
  return <Skeleton variant="text" width={'392px'} height={'2.13rem'} />;
}

export default HeaderFlagsLoader;
